/**
 * Activity Course Selector  Modal Messages
 *
 * This contains all the text for the Activity Course Selector Modal component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.course.builder.unit.activityCourseSelectorModal';

export default defineMessages({
  selectCourseware: {
    id: `${scope}.selectCourseware`,
    defaultMessage: 'Select Courseware',
  },
  moveCourseware: {
    id: `${scope}.moveCourseware`,
    defaultMessage: 'Move Courseware',
  },
  duplicateCourseware: {
    id: `${scope}.duplicateCourseware`,
    defaultMessage: 'Duplicate Courseware',
  },
  publicationCourseware: {
    id: `${scope}.publicationCourseware`,
    defaultMessage: 'Find your content',
  },
  searchCourseware: {
    id: `${scope}.searchCourseware`,
    defaultMessage: 'Search courseware',
  },
  selectProject: {
    id: `${scope}.selectProject`,
    defaultMessage: 'Select Project',
  },
  searchProject: {
    id: `${scope}.searchProject`,
    defaultMessage: 'Search project',
  },
  selectUnit: {
    id: `${scope}.selectUnit`,
    defaultMessage: 'Select Unit',
  },
  searchUnit: {
    id: `${scope}.searchUnit`,
    defaultMessage: 'Search unit',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  backButton: {
    id: `${scope}.backButton`,
    defaultMessage: 'Back',
  },
  nextButton: {
    id: `${scope}.nextButton`,
    defaultMessage: 'Next',
  },
  moveButton: {
    id: `${scope}.moveButton`,
    defaultMessage: 'Move',
  },
  selectButton: {
    id: `${scope}.selectButton`,
    defaultMessage: 'Select',
  },
  duplicateButton: {
    id: `${scope}.moveButton`,
    defaultMessage: 'Duplicate',
  },
  emptyStateMessage: {
    id: `${scope}.emptyStateMessage`,
    defaultMessage: 'No content found',
  },
});

